import Backbone from 'backbone';

export default Backbone.Model.extend({
  addresses: [],
  ownAddress: {},
  originalResponse: [],

  findByIndex: function(index) {
    var foundItem = false;

    this.get('addresses').forEach(function(item) {
      if (item.get('index') === index) {
        foundItem = item;

        return false;
      }
    });

    return foundItem;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/addressCheck/addressCheckViewModel.js
 **/